/* eslint-disable import/prefer-default-export */
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ISection } from '@CT-Types/section';
import { LessonAttendanceActivity } from '@components/Component/Lesson/LessonAttendance/types';
import { selectors } from './sectionsReducer';

export const useExamScore = () => {
  const { unitId, lessonId } = useParams();
  if (!unitId || !lessonId) {
    console.error('lessonId or unitId is undefined in useExamScore hook');
  }
  const examsScoreSummary = useSelector((state: any) => selectors.examsScoreSummaryByUnitAndLesson(state, unitId, lessonId));
  return examsScoreSummary;
};
export const useCurrentSection = (): ISection | undefined => {
  const { sectionId } = useParams();
  const currentSection = useSelector((state: any) => selectors.getSectionById(state, sectionId));
  return sectionId ? currentSection : undefined;
};
export const useSectionAttendanceList = () => {
  const { sectionId } = useParams();
  const sectionAttendanceList = useSelector((state: any) => selectors.getSectionAttendanceListBySectionId(state, sectionId));
  return sectionAttendanceList;
};

export const useSectionAttendanceListByActivityType = (activityType: LessonAttendanceActivity) => {
  const sectionAttendanceList = useSectionAttendanceList();
  return sectionAttendanceList.filter((attendance) => attendance.activity === activityType);
};
